
export function groupBy<T>(items: T[], cb: (item: T) => string | number): { [key: string]: T[] } {
	if (!items) return {}
	return items.reduce((acc, item) => {
		const key = cb(item)
		if (acc[key] == null) acc[key] = []
		acc[key].push(item)
		return acc
	}, {})
}

export function forObject<T, K>(object: { [key: string]: K }, cb: (key: string, value: K) => T): { [key: string]: T } {
	const newObject = {}
	for (const [key, value] of Object.entries(object)) {
		newObject[key] = cb(key, value)
	}
	return newObject
}

export function moveTo<T>(items: T[], from: number, to: number): T[] {
	if (items.length < 2) return items
	if (to < 0) to = 0
	if (from < 0) from = 0
	if (to > items.length - 1) to = items.length - 1
	if (from > items.length - 1) from = items.length - 1
	if (from == to) return items
	let tmp = items[from]
	items[from] = items[to]
	items[to] = tmp
	return items
}



/**
 * Recursively merges two objects, with properties from object2 taking precedence
 * If both objects have the same property and both values are objects, they will be merged recursively
 * @param object1 The first object
 * @param object2 The second object (will overwrite non-object properties in object1)
 * @returns A new object containing all properties from both objects
 */
export function mergeObjects<T extends object, U extends object>(object1: T, object2: U): T & U {
	const result = { ...object1 } as any;
	for (const key in object2) {
		if (Object.prototype.hasOwnProperty.call(object2, key)) {
			const value1 = (object1 as any)[key];
			const value2 = (object2 as any)[key];

			// If both values are objects, recursively merge them
			if (isObject(value1) && isObject(value2)) {
				result[key] = mergeObjects(value1, value2);
			} else {
				// Otherwise, value from object2 takes precedence
				result[key] = value2;
			}
		}
	}
	return result as T & U;
}
/**
 * Helper function to check if a value is an object (and not null or an array)
 * @param item The value to check
 * @returns True if the value is an object
 */
function isObject(item: any): boolean {
	return item !== null && typeof item === 'object' && !Array.isArray(item);
}